shadow$provide[240] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, addOrigin:{enumerable:true, get:function() {
  return addOrigin;
}}, recenterAxis:{enumerable:true, get:function() {
  return recenterAxis;
}}, setDimension:{enumerable:true, get:function() {
  return setDimension;
}}, setDimensionNormal:{enumerable:true, get:function() {
  return setDimensionNormal;
}}, setOrigin:{enumerable:true, get:function() {
  return setOrigin;
}}});
var require$three = require("three");
const setOrigin = function(vec, dimensions, origin) {
  if (+dimensions === dimensions) {
    dimensions = [dimensions];
  }
  const x = Array.from(dimensions).includes(1) ? 0 : origin.x;
  const y = Array.from(dimensions).includes(2) ? 0 : origin.y;
  const z = Array.from(dimensions).includes(3) ? 0 : origin.z;
  const w = Array.from(dimensions).includes(4) ? 0 : origin.w;
  return vec.set(x, y, z, w);
};
const addOrigin = function() {
  const v = new require$three.Vector4();
  return function(vec, dimension, origin) {
    setOrigin(v, dimension, origin);
    return vec.add(v);
  };
}();
const setDimension = function(vec, dimension) {
  const x = dimension === 1 ? 1 : 0;
  const y = dimension === 2 ? 1 : 0;
  const z = dimension === 3 ? 1 : 0;
  const w = dimension === 4 ? 1 : 0;
  return vec.set(x, y, z, w);
};
const setDimensionNormal = function(vec, dimension) {
  const x = dimension === 1 ? 1 : 0;
  const y = dimension === 2 ? 1 : 0;
  const z = dimension === 3 ? 1 : 0;
  const w = dimension === 4 ? 1 : 0;
  return vec.set(y, z + x, w, 0);
};
const recenterAxis = function() {
  const axis = [0, 0];
  return function(x, dx, bend, f) {
    if (f == null) {
      f = 0;
    }
    if (bend > 0) {
      const x1 = x;
      const x2 = x + dx;
      const abs = Math.max(Math.abs(x1), Math.abs(x2));
      const fabs = abs * f;
      const min = Math.min(x1, x2);
      const max = Math.max(x1, x2);
      x = min + (-abs + fabs - min) * bend;
      dx = max + (abs + fabs - max) * bend - x;
    }
    axis[0] = x;
    axis[1] = dx;
    return axis;
  };
}();

};